import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ClientLayout from '../../components/layout/ClientLayout';
import ChatPanel from '../../components/ChatPanel';
import { useAuth } from '../../context/AuthContext';
import { Loader2, MessageSquare } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ClientChatPage = () => {
  const { user } = useAuth();
  const [peer, setPeer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/chat/my-trainer`);
        setPeer(r.data.peer);
      } catch (e) {
        console.error('my-trainer', e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <ClientLayout>
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <MessageSquare className="h-6 w-6 text-primary" />
          <h1 className="text-2xl font-bold text-foreground">Mensajes</h1>
        </div>
        <p className="text-sm text-muted-foreground">
          Habla directo con tu entrenador. Las respuestas pueden tardar un rato.
        </p>

        <div className="h-[70vh] min-h-[500px]" data-testid="client-chat-container">
          {loading ? (
            <div className="flex items-center justify-center h-full">
              <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
            </div>
          ) : !peer ? (
            <div className="bg-card border border-border rounded-lg p-8 text-center text-muted-foreground">
              Todavía no tienes un entrenador asignado. Cuando te asignen uno, aparecerá aquí.
            </div>
          ) : (
            <ChatPanel peer={peer} currentUserId={user?.id} />
          )}
        </div>
      </div>
    </ClientLayout>
  );
};

export default ClientChatPage;
